import React, { useEffect, useState } from 'react'
import classes from "../../styles.module.css";
import { useNavigate } from 'react-router-dom';
import TitleSection from '../../../../common/TitleSection';
import { Helmet } from 'react-helmet';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';
import styles from "../../../../ContentStyling.module.css";

const FeettoMeters = () => {
    const [inputValue, setInputValue] = useState();
    const [outputValue, setOutputValue] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize Google Ads
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          console.error("AdSense run successfully");
        } catch (e) {
          console.error("AdSense error", e);
        }
      }, []);

      const convertFeetToMeters = () => {
        // Validate input: allow numbers, decimals, and optional minus sign
        if (!/^-?\d+(\.\d+)?$/.test(inputValue)) {
            setErrorMessage("Please enter a valid length in feet (e.g., 5, 6.25).");
            setOutputValue("");
            return;
        }

        setErrorMessage("");
        const feetValue = parseFloat(inputValue); // Convert input string to a number
        const meterValue = feetValue * 0.3048; // 1 foot = 0.3048 meters
        setOutputValue(meterValue.toFixed(6)); // Limit output to 6 decimal places
    };


      const handleClearBtn = () => {
        setInputValue("");
        setOutputValue("");
        setErrorMessage("");
      }

      const handleSwapClick = () => {
        navigate("/converters/meters-to-feet");
    };

        

  return (
    <div className={classes.page}>
      <Helmet>
                <title>Feet to Meters Converter - Wiraa tools</title>
                <meta name="description" content="Easily convert feet to meters using our online conversion tool. Accurate results with simple calculations for your length measurements. Try now!" />
        </Helmet>
    <div className={classes.container}>
       <TitleSection
                          icon="https://cdn-icons-png.flaticon.com/128/570/570968.png"
                          title="Feet To Meters Converter"
                          subTitle="Effortlessly Convert Feet To Meters for Accurate Measurements"
                        />
      <div className={classes.innerCon}>
        <div className={classes.inputCon}>
            <p className={classes.inputplaceholder}>Feet Value</p>
            <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} className={classes.inputfield} placeholder='Enter feet value'/>
            {errorMessage && <p className={classes.errorMsg}>{errorMessage}</p>}
        </div>
        <div className={classes.btnCon}>
            <button className={classes.convertBtn} onClick={convertFeetToMeters}>Convert</button>
            <button className={classes.clearBtn} onClick={handleClearBtn}>Clear</button>
            <button className={classes.swapBtn} onClick={handleSwapClick}>Swap</button>
        </div>
        <div className={classes.outputCon}>
            <p className={classes.outputplaceholder}>Meters Value</p>
            <p className={classes.outputfield}>{outputValue}</p>
        </div>
      </div>
      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>
     <div className={styles.contentContainer}>
      <p>The Feet to Meters Converter is a vital tool for professionals, students, and anyone working with distance measurements. It allows you to convert feet (ft) to meters (m) instantly and accurately, making it perfect for construction, architecture, travel, or education.</p>
      <p>This converter ensures smooth transitions between imperial and metric systems—essential for global collaboration and technical accuracy.</p>
      <h3>What Are Feet and Meters?</h3>
      <p><b>Feet (ft): </b>A unit of length in the imperial system, widely used in the United States and U.K. <br /> 1 foot = 12 inches</p>
      <p><b>Meters (m): </b> A standard unit in the metric system, commonly used worldwide in science, engineering, and daily life. <br /> 1 meter = 100 centimeters</p>
      <p><b>Conversion Formula: </b>1 foot = 0.3048 meters</p>
      <h3>Why Convert Feet to Meters?</h3>
      <ul>
        <li><b>Global Standardization:</b> Most countries and scientific fields use meters.</li>
        <li><b>Engineering & Construction:</b> Meters are standard in blueprints, equipment, and documentation.</li>
        <li><b>Accuracy:</b> Converting to meters helps avoid confusion in international projects.</li>
      </ul>
      <h3>How to Use the Feet to Meters Converter</h3>
      <ol>
        <li><b>Enter Feet Value:</b> Type the value in feet.</li>
        <li><b>Click Convert:</b> The tool will instantly show the equivalent in meters.</li>
        <li><b>Use the Result:</b> Apply the converted measurement in your plans, reports, or calculations.</li>
      </ol>
      <h3>Conversion Examples:</h3>
      <ul>
        <li>1 ft → 0.3048 m</li>
        <li>3 ft → 0.9144 m</li>
        <li>5 ft → 1.524 m</li>
        <li>6.2 ft → 1.88976 m</li>
      </ul>
      <h3>Benefits of Using Feet to Meters Converter</h3>
      <ul>
        <li><b>Quick & Accurate:</b> No manual math required.</li>
        <li><b>User-Friendly:</b> Ideal for all skill levels.</li>
        <li><b>Reliable:</b> Based on exact international conversion factors.</li>
      </ul>
      <h3>Who Is This Tool For?</h3>
      <ul>
        <li>Architects & Engineers working with international standards</li>
        <li>Travelers & Students converting height, maps, or building specs</li>
        <li>DIYers & Contractors who handle diverse measurement systems</li>
        <li>Educators & Learners practicing unit conversions</li>
      </ul>
     </div>
    </div>
   </div>
  )
}

export default FeettoMeters;
